// Copyright (c) 2020 Sagacity Solutions Inc. All right reserved.
'use strict';

import { Reminder } from '@/models';

export const ui_version = process.env.VUE_APP_VERSION || "dev"
export const api_version = ui_version;

let origin = "http://localhost:1234"
if (process.env.NODE_ENV == "production") {
  origin = location.origin
}

export const apiURL = origin + '/adherence/';

export const defaultNotification = {
  "None": [],
  "Reminder Notification": {'en': [
    new Reminder("Hi <patient_reference>, it's time to take your medication. Kind regards <organization_range>.", -60),
    new Reminder("Hi <patient_reference>, you've still not taken your medication. Please make sure to do so. " +
                 "Kind regards, <organization_name>.",
                 -15),
    new Reminder("Hi <patient_reference>, your medication should have been taken by now. " +
                 "Please make sure to do so, and please contact your healthcare professional if anything is wrong. " +
                 "Kind regards, <organization_name>", 0)],
                            'es': [
    new Reminder("Hola <patient_reference>, es hora de timar su medicación. Saludos <organization_range>.", -60),
    new Reminder("Hola <patient_reference>, todavía no ha tomado su medicación. Por favor, asegúrate de hacerlo. Saludos <organization_range>.", -15),
    new Reminder("Hola <patient_reference>, su medicación ya debería haber sido tomada. Por favor, asegúrese de hacerlo y por favor, comuníquenos si algo va mal. Saludos <organization_range>.", 0)],
                           },
  "Missing Notification": {'en': [
    new Reminder("Hi <patient_reference>, your medication should have been taken by now. " +
                 "Please make sure to do so, and please contact your healthcare professional " +
                 "if anything is wrong. Kind regards, <organization_name>",
                 0)],
                           'es': [
    new Reminder("Hola <patient_reference>, su medicación ya debería haber sido tomada. Por favor, asegúrese de hacerlo y por favor, comuníquenos si algo va mal. Saludos <organization_range>.", 0)],
                            },
"Monitoring Only": {'en': [
    new Reminder("<patient_reference> has missed their last dose by 1 hour", 60)],
                    'es': [
    new Reminder("<patient_reference> ha olvidado su última dosis de hace 1 hora", 60)],
                   },
};
